import { useState, useEffect, useCallback } from 'react';
import { getToken } from '../../Utils/Common';

const REACT_APP_BACKEND_API_URI = process.env.REACT_APP_BACKEND_API_URI;
const orgID = sessionStorage.getItem("org");

const useTextTemplates = () => {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchTemplates = useCallback(async () => {
        try {
            setLoading(true);
            const fetchTemplate = async (textType) => {
                let apiBody = {
                    "token": getToken(),
                    "data": {
                        orgID,
                        "textType": textType,
                        // "active": true
                    }
                };
                const response = await fetch(`${REACT_APP_BACKEND_API_URI}mobileappbackend/get_text_template`, {
                    body: JSON.stringify(apiBody),
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                return await response.json();
            };

            const [stundenlohnTemplates, stoerungTemplates, behinderungTemplates] = await Promise.all([
                fetchTemplate("Stundenlohn-Anmeldung"),
                fetchTemplate("Störung"),
                fetchTemplate("Behinderung-Anmeldung")
            ]);

            setTemplates([
                ...stundenlohnTemplates.text_list,
                ...stoerungTemplates.text_list,
                ...behinderungTemplates.text_list
            ]);
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    }, []);

    const createTemplate = async ({ templateHeadline, templateText, active, textTemplateID, templateType }) => {
        try {
            setLoading(true);
            const apiBody = {
                "data": {
                    orgID,
                    textType: templateType,
                    templateText,
                    templateHeadline,
                    active,
                    textTemplateID,
                },
                "token": getToken(),
            };
            const response = await fetch(`${REACT_APP_BACKEND_API_URI}mobileappbackend/create_texttemplate`, {
                body: JSON.stringify(apiBody),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            const data = await response.json();
            if (data.status === 200) {
                fetchTemplates();
            }
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    const editTemplate = async ({ templateHeadline, templateText, active, textTemplateID, templateType }) => {
        try {
            setLoading(true);
            const apiBody = {
                "data": {
                    orgID,
                    textType: templateType,
                    templateText,
                    templateHeadline,
                    active,
                    textTemplateID,
                },
                "token": getToken(),
            };
            const response = await fetch(`${REACT_APP_BACKEND_API_URI}mobileappbackend/create_texttemplate`, {
                body: JSON.stringify(apiBody),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            const data = await response.json();
            if (data.status === 200) {
                fetchTemplates();
            }
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    const deleteTemplate = async (textTemplateID) => {
        try {
            setLoading(true);
            const apiBody = {
                "data": {
                    orgID,
                    textTemplateID,
                },
                "token": getToken(),
            };
            const response = await fetch(`${REACT_APP_BACKEND_API_URI}mobileappbackend/delete_texttemplate`, {
                body: JSON.stringify(apiBody),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            const data = await response.json();
            if (data.status === 200) {
                fetchTemplates();
            }
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, [fetchTemplates]);

    return { templates, loading, error, createTemplate, editTemplate, deleteTemplate };
};

export default useTextTemplates;
